import { generateEntityCrudReducer } from 'syft-acp-util/store/reducers'
import { CsatAgencyEntity } from './types'
import csatAgencyTypes from './action-types'

export default generateEntityCrudReducer<CsatAgencyEntity>({
  name: 'csatAgencies',
  actions: csatAgencyTypes,
})
